import React from "react";
import { Link } from "react-router-dom";
import * as CONFIG from "./_config";
import ls from "local-storage";

const axios = require("axios");

function RewardDetailsModal({ value, reedemoptions }) {
    var MemberNumber = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
        ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).MemberNumber
        : "";
    return (
        <div class="modal" id="RewardDetailsShowModal">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header" style={{ backgroundColor: "#f4f4f4" }}>
                        <h4 class="modal-title">REWARD DETAILS</h4>
                        <button type="button" class="close" data-dismiss="modal">
                            &times;
                        </button>
                    </div>

                    <div class="modal-body reward-detail-item" style={{ textAlign: "center" }}>
                        <h4 className="member-title" style={{ textAlign: "center" }}>
                            Member Number: {MemberNumber}
                        </h4>
                        <tr className="modal-reward">
                            <td>
                                <img
                                    src={value.RewardImageURL}
                                    alt=""
                                    style={{
                                        width: "150px",
                                        height: "150px",
                                    }}
                                />
                            </td>
                            <td>
                                <p>{value.PurchasedAmountString}</p>
                                <p> {value.RewardPurchasedAmountText}</p>
                            </td>
                        </tr>
                        <div className="modal-reward-title">
                            <h4>{value.Title}</h4>
                            <p className="modal-reward-desc">{value.RewardDetails}</p>
                        </div>
                        <div className="reward-desc-title">
                            <h2>Rewards Options</h2>
                            <div className="reward-items-wrapper">
                                {reedemoptions?.map((each) => (
                                    <tr style={{}} className="reward-modal-items">
                                        <td style={{ width: "25%", borderRight: 0, padding: "33px 12px" }}>
                                            <Link to="#">
                                                <div
                                                    className="product-image"
                                                    style={{
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <img
                                                        alt="img"
                                                        src={each?.TierImageUrl}
                                                        style={{
                                                            width: "50%",
                                                        }}
                                                    />
                                                </div>
                                            </Link>
                                        </td>
                                        <td
                                            className="reward-table"
                                            style={{ padding: "50px 35px 50px 0" }}
                                        >
                                            <div
                                                className="product-title"
                                                style={{
                                                    display: "block",
                                                    flexDirection: "column",
                                                    textAlign: "left",
                                                }}
                                            >
                                                <p>{each?.PointsRequiredString}</p>
                                                <span>{each?.TierTitle}</span>
                                            </div>
                                        </td>
                                        <div></div>
                                    </tr>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer" style={{
                        padding: "10px 16px"
                    }}>
                        <Link to="#" data-dismiss="modal">
                            <button
                                className={`btn btn-success ${CONFIG.DATA.CARDENAS_UI ? `cardenasmarkets-border-radius` : ``
                                    }`}
                                style={{
                                    backgroundColor: "#b30838 ",
                                    color: "white",
                                }}
                            >
                                Cancel
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RewardDetailsModal;
